<!--
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-04-01 16:39:04
 * @LastEditors: Li Yong
 * @LastEditTime: 2022-04-20 13:40:24
-->
<template>
	<el-select v-bind="$attrs" v-model="userId" clearable filterable :placeholder="placeholder" @change="change">
		<el-option v-if="hasUnassigned" label="未归属" value="0"></el-option>
		<el-option :label="item.name" :value="item.userId" v-for="(item, index) in optionList" :key="index">
			<div class="flex flex-align-center">
				<span class="mr-8">{{ item.name }}</span>
				<el-tag v-if="item.deleted" type="danger" size="mini" effect="plain">账号已删除</el-tag>
				<el-tag v-else-if="item.use_status == 2" type="danger" size="mini">账号已停用</el-tag>
			</div>
		</el-option>
	</el-select>
</template>
<script>
import { commonList } from '@/api/cooperationProgress';
import { drRoleType } from '@/utils/dataMap';
import { commonAllUser, getDrSelectList } from '@/api/teamManage';
export default {
	name: 'DrPartnerSelect',
	props: {
		value: [String, Number, Array],
		placeholder: {
			type: String,
			default: `请选择 / 搜索${drRoleType.name}`,
		},
		customData: {
			type: Array,
			default: _ => [],
		},
		// basedOnAuth: {
		// 	type: Boolean,
		// 	default: false,
		// },
		// 是否有未归属
		hasUnassigned: {
			type: Boolean,
			default: false,
		},
		apiType:{
			type: Number,
			default: 0,
		}
	},
	watch: {
		value(val) {
			this.userId = val;
		},
	},
	data() {
		return {
			userId: this.value,
			optionList: [],
		};
	},
	mounted() {
		this.getCateList();
	},
	methods: {
		change(val) {
			this.$emit('input', val);
			this.$emit('change', val);
		},
		async getCateList() {
			const apiMaps = new Map([[0,commonList],[1,commonAllUser],[2,getDrSelectList]]);
			//达人商务
			const { code, data } = await apiMaps.get(this.apiType)({ role_id: drRoleType.id, all_status: 1 });
			if (code === 0) {
				this.optionList = [...this.customData, ...data];
				// 将数组分成三个部分
				const notUseStatus2AndNotDeleted = this.optionList.filter(item => item.use_status !== '2' && !item.deleted);
				const useStatus2 = this.optionList.filter(item => item.use_status === '2' && !item.deleted);
				// const deleted = this.optionList.filter(item => item.deleted);
				// 合并三个部分 删除账号不显示, ...deleted
				this.optionList = [...notUseStatus2AndNotDeleted, ...useStatus2];
			}
		},
		reset() {
			this.userId = [];
		},
	},
};
</script>
